import { useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Link } from 'react-router-dom';
import MaskedInput from 'react-text-mask';
import { maskCpfCnpj, unMask } from '../../../utils/masks';
import { API_URL } from '../../../services/api';
import { RedirectTo } from '../../../utils/redirectTo';
import { PasswordInput } from '../../shared/PasswordInput';
import { Container } from './styles';

export function ResetPassword() {
  const { search } = useLocation();

  const [loading, setLoading] = useState(false);
  const [cpfCnpj, setCpfCnpj] = useState('');
  // O link do e-mail chega como /resetPassword?code=XXXXXX. Sem o `?? ''` o
  // input controlado receberia null quando a pessoa abre a tela sem o código.
  const [code, setCode] = useState(
    () => new URLSearchParams(search).get('code') ?? ''
  );
  const [password, setPassword] = useState('');
  const [passwordConfirmation, setPasswordConfirmation] = useState('');

  const history = useHistory();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password !== passwordConfirmation) {
      return toast.error('As senhas devem ser idênticas.');
    }

    setLoading(true);

    const body = {
      cpfCnpj: unMask(cpfCnpj),
      code,
      password,
    };

    try {
      const res = await fetch(`${API_URL}/reset-password`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      });

      const response = await res.json();

      if (!res.ok) {
        toast.error(response.message);
      } else {
        toast.success(response.message);
        setCpfCnpj('');
        setCode('');
        setPassword('');
        setPasswordConfirmation('');

        setTimeout(() => history.push(RedirectTo.login), 5000);
      }
    } catch (e) {
      toast.error('Não foi possível concluir a alteração. Verifique sua conexão e tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>
      <ToastContainer />

      <h2>Alterar senha</h2>

      <p>
        Informe o código que recebeu no e-mail e escolha a sua nova senha.
      </p>

      <form onSubmit={handleSubmit}>
        <MaskedInput
          mask={maskCpfCnpj}
          placeholder="Cpf ou Cnpj"
          aria-label="Cpf ou Cnpj"
          guide={false}
          type="text"
          value={cpfCnpj}
          onChange={(event) => setCpfCnpj(event.target.value.toUpperCase())}
          autoFocus
          required
        />

        <input
          placeholder="Código de verificação"
          aria-label="Código de verificação"
          type="text"
          value={code}
          onChange={(event) => setCode(event.target.value)}
          pattern=".{4,8}"
          title="Informe de 4 a 8 caracteres"
          maxLength="8"
          required
        />

        <PasswordInput
          placeholder="Nova senha"
          aria-label="Nova senha"
          autoComplete="new-password"
          value={password}
          onChange={(event) => setPassword(event.target.value)}
          required
        />

        <PasswordInput
          placeholder="Confirme a nova senha"
          aria-label="Confirme a nova senha"
          autoComplete="new-password"
          value={passwordConfirmation}
          onChange={(event) => setPasswordConfirmation(event.target.value)}
          required
        />

        {loading ? (
          <button disabled type="submit">
            Alterando
          </button>
        ) : (
          <button type="submit">Alterar</button>
        )}

        <Link to={RedirectTo.login}>
          <button className="secondButton">Voltar ao login</button>
        </Link>
      </form>
    </Container>
  );
}
